<template>
    <div>
        <tb-skeleton v-if="!initialized" :height="100" :theme="'opacity'" :shape="'radius'" bg-color="#dcdbdc"></tb-skeleton>

        <div v-else-if="signatures">
            <div class="card">
                <div class="card-header bg-light">
                    <h5 class="card-title">Newport</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <div style="border: 1px solid #CCCCCC; padding: 10px;" v-html="signatures.newport_sign_html"></div>
                        </div>
                        <div class="col">
                            <editor v-model="signatures.newport_sign_html_min"></editor>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card">
                <div class="card-header bg-light">
                    <h5 class="card-title">Supékort</h5>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col">
                            <div style="border: 1px solid #CCCCCC; padding: 10px;" v-html="signatures.supekort_sign_html"></div>
                        </div>
                        <div class="col">
                            <editor v-model="signatures.supekort_sign_html_min"></editor>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="not_found">
            <i>Användaren finns inte</i>
        </div>
        <div v-else>
            <i>Något gick fel...</i>
        </div>
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import Editor from '@components/Editor.vue';

export default {
    components: {
        Editor,
    },
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
    },
    data: () => ({
        initialized: false,
        not_found: false,
        signatures: null,
    }),
    mounted() {
        this.getUser();
    },
    methods: {
        getUser() {
            apiClient.get('/vue/users/' + this.id + '/email_signature')
                .then((response) => {
                    this.signatures = response.data;
                })
                .catch((error) => {
                    const { status } = error.response;
                    if (status === 404) {
                        this.not_found = true;
                    }
                })
                .finally(() => {
                    this.initialized = true;
                });
        },
    },
};

</script>
